import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dcbedaf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("DOCUMENT "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" MAKER")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Поможем вам "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" сформировать документы")
], -1))
const _hoisted_5 = { class: "form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Введите логин", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Введите пароль", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "или", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginLogo = _resolveComponent("LoginLogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LoginLogo),
      _hoisted_3
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "Введите логин",
          maxlength: "50",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.login) = $event))
        }, null, 512), [
          [_vModelText, _ctx.login]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          type: "password",
          placeholder: "Введите пароль",
          maxlength: "50",
          onkeypress: "return event.charCode >= 48 && event.charCode <= 57",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pwd) = $event))
        }, null, 512), [
          [_vModelText, _ctx.pwd]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "blue_btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.next_page()))
        }, "Войти"),
        _hoisted_8,
        _createElementVNode("button", {
          type: "button",
          class: "blue_btn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.signup()))
        }, "Зарегистрироваться")
      ]),
      _createElementVNode("span", {
        style: {"cursor":"pointer"},
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.recovery()))
      }, "Забыли пароль?")
    ])
  ]))
}